import axios from 'axios'
import { joinURL } from 'ufo'
import { bypassAdmin } from 'src/stores/admin'
import { getApiUrl, runtimeConfig } from 'src/utils/config'
import { getFingerprint } from 'src/utils/fingerprint'
import {
  setIntercomUserJwt,
  unsetIntercomUserJwt,
} from 'src/utils/intercom/storage'
import { getToken, setToken } from '../utils/token'
import { setIPCountry } from './helpers/ip'

export const baseClient = axios.create({
  baseURL: getApiUrl(),
  validateStatus: null,
  withCredentials: true,
})

baseClient.interceptors.request.use(opt => {
  const token = getToken()
  if (token) {
    opt.headers.set('Authorization', `Bearer ${token}`)
  }

  if (bypassAdmin()) {
    opt.headers.set('X-Bypass-Admin', '1')
  }

  const browserId = getFingerprint()
  if (browserId) {
    opt.headers.set('X-Browser-ID', browserId)
  }

  if (opt.url === '/v1/events/status') {
    const buildTimestamp = runtimeConfig.buildTimestamp
    if (buildTimestamp) {
      opt.headers.set('X-Build-Timestamp', buildTimestamp)
    }
  }

  return opt
})

baseClient.interceptors.response.use(res => {
  if (res.status === 401) {
    setToken('')
    unsetIntercomUserJwt()
  } else {
    const token = res.headers.token
    if (token) {
      setToken(token)
    }
  }
  return res
})

baseClient.interceptors.response.use(res => {
  const intercomUserJwt = res.headers['x-intercom-user-jwt']
  if (intercomUserJwt) {
    setIntercomUserJwt(intercomUserJwt)
  }
  const ipCountry = res.headers['x-country-code']
  if (ipCountry) {
    setIPCountry(ipCountry)
  }
  return res
})

export const controlNetClient = axios.create({
  baseURL: 'https://controlnet.pixai.art',
  withCredentials: true,
})

controlNetClient.interceptors.request.use(opt => {
  const token = getToken()
  if (token) {
    opt.headers.set('Authorization', `Bearer ${token}`)
  }
  return opt
})

export const promptsRewriterClient = axios.create({
  baseURL: getApiUrl() + '/inference/prompts-rewriter',
  withCredentials: true,
})

promptsRewriterClient.interceptors.request.use(opt => {
  const token = getToken()
  if (token) {
    opt.headers.set('Authorization', `Bearer ${token}`)
  }
  return opt
})

export const faceDetectorClient = axios.create({
  baseURL: 'https://api.pixai.art/inference/face-detector',
  withCredentials: true,
})

faceDetectorClient.interceptors.request.use(opt => {
  const token = getToken()
  if (token) {
    opt.headers.set('Authorization', `Bearer ${token}`)
  }
  opt.headers.set('Accept', 'application/json')
  return opt
})

export const dynamicConfigClient = axios.create({
  baseURL: joinURL(getApiUrl(), '/config'),
  withCredentials: true,
})
dynamicConfigClient.interceptors.request.use(opt => {
  const token = getToken()
  if (token) {
    opt.headers.set('Authorization', `Bearer ${token}`)
  }
  opt.headers.set('Accept', 'application/json')
  return opt
})
